/*
Shop Supplies
 */

const name = 'Shop Supplies'
const id = 'wQaUTQqKutlYWsPf05dj'

export default {
  name,
  id
}
